import * as React from "react";
import { Utilities } from "../../shared/utilities";
import useUserTheme from "../../shared/styles/hooks/useUserTheme";
import { ThemeType } from "../../shared/styles/theme";
import colors from "../../shared/styles/colors";

const LEGACY_AGENTS_EOL_DISMISSED_KEY = "frends_legacy_agents_eol_dismissed";

const useLegacyAgentsEolToast = (hasLegacyAgents: boolean) => {
    const [currentTheme] = useUserTheme();

    React.useEffect(() => {
        if (!hasLegacyAgents) {
            return;
        }

        if (sessionStorage.getItem(LEGACY_AGENTS_EOL_DISMISSED_KEY)) {
            return;
        }

        const textStyle: React.CSSProperties = {
            color: currentTheme === ThemeType.light ? colors.grey_1 : colors.grey_5,
            fontSize: "16px",
            fontFamily: "Gilroy",
            wordWrap: "break-word",
        };

        const toastContent = (
            <div style={{ width: "318px" }}>
                <span style={{ ...textStyle, fontWeight: 700 }}>
                    {"Legacy Agents are approaching end of life "}
                </span>
                <span style={{ ...textStyle, fontWeight: 400 }}>
                    {"and will no longer be supported in future versions of Frends."}
                    <br /><br />
                    {"You can continue to use Legacy Agents, but in a future release they will stop working."}
                    <br /><br />
                </span>
                <span style={{ ...textStyle, fontWeight: 700 }}>
                    {"To avoid any issues, we recommend you update your processes to use the new cross-platform Agents."}
                </span>
            </div>
        );

        const handleDismiss = () => {
            sessionStorage.setItem(LEGACY_AGENTS_EOL_DISMISSED_KEY, "true");
        };

        Utilities.toastWarning(toastContent, true, true, "legacy-agents-warning", handleDismiss);
    }, [currentTheme, hasLegacyAgents]);
};

export default useLegacyAgentsEolToast;